import "../elements/add-post-modal";
import "../elements/article-body";
import "../elements/article-on-page-nav";
import "../elements/checkbox-collapse";
import "../elements/city-lookup";
import "../elements/context-pane";
import "../elements/cookie-info";
import "../elements/loading-button";
import "../elements/cookie-info-link";
import "../elements/counter-ticker";
import "../elements/delete-file";
import "../elements/dismissable-alert";
import "../elements/edit-post-modal";
import "../elements/file-directory";
import "../elements/file-picker";
import "../elements/global-navigation";
import "../elements/hero";
import "../elements/my-courses-dialog";
import "../elements/multi-file-picker";
import "../elements/on-page-nav";
import "../elements/proxy-date-updater";
import "../elements/right-salary";
import "../elements/simple-filter";
import "../elements/salary-statistics";
import "../elements/select-collapse";
import "../elements/tiny-mce";
import "../elements/validation-form";
import "../elements/workplace-autocomplete";

import "../validation/organisationnumber";
import "../validation/requiredif";
import "../validation/requiredtrue";
import "../validation/requiredifwithoveride";
import "../validation/requriedyearandmonth";
import "../validation/unique";
import "../validation/validation";
import "../validation/validforbund";

// HTML has loaded
document.addEventListener("DOMContentLoaded", () => {

    // Add code here

}, false);

// Images, etc has loaded
window.addEventListener("load", () => {

    // Add code here

});